import React, { useState } from 'react';
import { Button, Card, message, Typography } from 'antd';
import { makeUserSuperAdmin } from '../../utils/createAdmin';

const { Title, Text } = Typography;

const MakeSuperAdmin = () => {
  const [loading, setLoading] = useState(false);

  const handleMakeSuperAdmin = async () => {
    setLoading(true);
    try {
      const result = await makeUserSuperAdmin('curtiss@indcg.com');
      if (result.success) {
        message.success(`✅ Success! ${result.email} is now a super admin!`);
        console.log('User ID:', result.userId);
      } else {
        message.error(`❌ Failed: ${result.error}`);
      }
    } catch (error) {
      message.error(`❌ Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card style={{ maxWidth: 500, margin: '50px auto' }}>
      <Title level={3}>Make Super Admin</Title>
      <Text>
        This will make <strong>curtiss@indcg.com</strong> a super admin with full access to all admin features.
      </Text>
      <br /><br />
      <Button 
        type="primary" 
        onClick={handleMakeSuperAdmin}
        loading={loading}
        size="large"
      >
        Make Curtiss Super Admin
      </Button>
      <br /><br />
      <Text type="secondary" style={{ fontSize: '12px' }}>
        Note: This will update the user's role in Firestore to admin with isSuperUser: true
      </Text>
    </Card>
  );
};

export default MakeSuperAdmin;
